<template>
  <v-app style="background-color: #edf2f2">
    <v-content>
      <v-layout mt-2 row wrap align-center justify-center>
        <v-flex xs7 md7 lg7 pl-5>
          <v-card class="mx-auto elevation-0" outlined color="transparent">
            <v-card-title>
              <v-avatar class="mr-3" :color="_pageDetailcolor">
                <v-icon dark>mdi-text-box-search</v-icon>
              </v-avatar>

              <b :style="'font-size: 18px; color:' + _pageDetailcolor">
                {{ $t("view_invoice.title") }}
              </b>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex sm8 md5 lg5 text-right pr-10>
          <DialogTestSystem></DialogTestSystem>
        </v-flex>
      </v-layout>
      <v-container grid-list-lg fluid mt-2>
        <v-layout row wrap justify-center align-center>
          <v-flex lg11 xs11 pl-4 pr-4 pt-5>
            <v-card flat class="rounded-lg elevation-0 container">
              <v-card-actions>
                <!--color="warning"-->
                <v-btn
                  large
                  color="warning"
                  block
                  @click="fn_backIndex()"
                  class="btn-back"
                >
                  <v-icon color="white" class="mr-2"
                    >mdi-arrow-left-circle</v-icon
                  >
                  <h3 class="white--text">
                    {{ $t("create_invoice.button_home") }}
                  </h3>
                </v-btn>
              </v-card-actions>
              <br />
              <v-card-text>
                <embed
                  v-if="pdfUrl != null && pdfUrl != ''"
                  :src="'data:application/pdf;base64,' + pdfUrl"
                  class="responsive-iframe"
                  height="100%"
                  width="100%"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-overlay :value="loadingDownloadData">
          <div class="text-center">
            {{ $t("create_bill.dowloadind_data") }}
          </div>
          <v-progress-circular
            indeterminate
            size="70"
            class="ml-9 mt-3"
          ></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import authorization from "@/authorization/authorization.js";
import DialogTestSystem from "@/components/portal/dialog/dialog-test-system";
import swal from "sweetalert2";
//import TestSystem from "@/components/webportals/pages/test-system.vue"
import { mapGetters, mapState } from "vuex";
export default {
  name: "portal_setting_signing",
  components: {
    //TestSystem,
    DialogTestSystem,
  },
  data: () => ({
    taxid: "",
    loadingDownloadData: false,
    pdfUrl: "",
  }),
  async mounted() {
    await this.fn_preview();
  },
  methods: {
    fn_backIndex() {
      this.$router.push("/portal/create_bill_index");
    },
    fn_preview: async function () {
      this.loadingDownloadData = true;
      var payload = {
        taxid: this._taxId,
        transactionCode: this.$route.query.id,
        branchid: this._SellerBranchId,
        seller_id: localStorage.etax_sellerid,
        web_service: "R2",
        usercode: localStorage.etax_username,
      };
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(this._taxId);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_CREATE_BILL_API + "getdocument",
          { data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.status == "OK") {
            this.pdfUrl = response.data.File;
          } else {
            swal.fire(
              this.$t("alert.fail"),
              response.data.errorMessage,
              "error"
            );
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            swal.fire(
              this.$t("alert.fail"),
              this.$t("confirm.swal.catch_err") +
                JSON.stringify(error.response.data.errorMessage),
              "error"
            );
          } else if (error.request) {
            swal.fire(
              this.$t("alert.fail"),
              this.$t("confirm.swal.catch_err") + error.request,
              "error"
            );
          } else {
            swal.fire(
              this.$t("alert.fail"),
              this.$t("confirm.swal.catch_err") + error.message || error,
              "error"
            );
          }
        });
    },
  },
  computed: {
    ...mapGetters(["getter_dataBusiness_profile"]),
    ...mapState(["backgroudcolor", "pageDetailcolor"]),
    // New Add
    _taxId: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    _backgroudcolor: {
      get() {
        return this.backgroudcolor;
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    _SellerBranchId: {
      get() {
        return this.getter_dataBusiness_profile["branch_no"];
      },
    },
  },
  watch: {
    inputProduct: {
      handler: function (newValue) {
        this.fn_calculate();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.btn-round {
  border-radius: 15px;
}
table,
tbody,
tr,
td {
  border: none !important;
}
.Customer-text-field__selector.hide {
  display: none;
}
.responsive-iframe {
  width: 100% !important;
  height: 1200px !important;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  position: absolute;
  top: 8px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
.container {
  position: relative;
  /* width: 100%;
  overflow: hidden; */
}
.btn-back {
  position: absolute;
  top: -35px;
  left: 0px;
}
</style>
